import { View } from "ui/atoms/view";
import { Text } from "react-native";
export interface Props {
  children?: React.ReactNode;
  title: string;
  subtitle?: string;
  titleClassNames?: string;
}

export function HandoverSection({
  children,
  title,
  subtitle,
  titleClassNames,
}: Props) {
  return (
    <View className="py-10 first:pt-0 border-b border-t border-border-200 first:border-t-0 last:border-b-0">
      <View className="mb-4">
        <Text className={`text-lg font-semibold ${titleClassNames}`}>
          {title}
        </Text>
        {subtitle ? (
          <Text className={`text-sm text-gray-500 mb-8 ${titleClassNames}`}>
            {subtitle}
          </Text>
        ) : null}
      </View>
      <View>{children}</View>
    </View>
  );
}
